import React, { useState } from "react";
import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";

interface ChurnSearchProps {
  onSearch: (filters: {
    startDate: Date;
    endDate: Date;
    daysSinceLastOrder: number | null;
  }) => void;
  onReset: () => void;
}

const ChurnSearch: React.FC<ChurnSearchProps> = ({ onSearch, onReset }) => {
  const today = new Date();
  const defaultStart = new Date();
  defaultStart.setFullYear(defaultStart.getFullYear() - 1);

  const [startDate, setStartDate] = useState<Date>(defaultStart);
  const [endDate, setEndDate] = useState<Date>(today);
  const [daysSinceLastOrder, setDaysSinceLastOrder] = useState<number | null>(60);

  const handleSearch = () => {
    onSearch({ startDate, endDate, daysSinceLastOrder });
  };

  const handleReset = () => {
    const newStart = new Date();
    newStart.setFullYear(newStart.getFullYear() - 1);
    setStartDate(newStart);
    setEndDate(new Date());
    setDaysSinceLastOrder(60);
    onReset();
  };

  return (
    <div className="col-12">
      <div className="card border-noround p-3">
        <div className="grid">
          <div className="col-12 sm:col-6 lg:col-3">
            <label className="block text-sm font-medium mb-1">Start Date</label>
            <Calendar
              value={startDate}
              onChange={(e) => setStartDate(e.value as Date)}
              dateFormat="dd/mm/yy"
              showIcon
              className="w-full"
            />
          </div>
          <div className="col-12 sm:col-6 lg:col-3">
            <label className="block text-sm font-medium mb-1">End Date</label>
            <Calendar
              value={endDate}
              onChange={(e) => setEndDate(e.value as Date)}
              dateFormat="dd/mm/yy"
              showIcon
              className="w-full"
            />
          </div>
          <div className="col-12 sm:col-6 lg:col-3">
            <label className="block text-sm font-medium mb-1">
              Days Since Last Order (≥)
            </label>
            <InputNumber
              value={daysSinceLastOrder}
              onValueChange={(e) => setDaysSinceLastOrder(e.value ?? null)}
              placeholder="Default: 60 (shows ≥60 days)"
              min={0}
              className="w-full"
            />
          </div>
          <div className="col-12 sm:col-6 lg:col-3 flex align-items-end justify-content-end gap-2">
            <Button
              label="Reset"
              icon="pi pi-refresh"
              className="p-button-outlined p-button-secondary"
              onClick={handleReset}
            />
            <Button
              label="Filter"
              icon="pi pi-filter"
              onClick={handleSearch}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChurnSearch;
